import React, { useCallback } from 'react'
import { makeStyles, TextField } from '@material-ui/core'
import { PeriodTypeToString } from '../SessionPeriods'

import { Period } from '../../../services/sessionModels'
import { TSession } from '../Sessions'
import { TLabelTask } from './SessionLabelTask'
import BallActionList, { BallAction } from './BallActionList'
import { findPeriodForFrames } from './sessionLabelOverviewReducer'

const useStyles = makeStyles(() => ({
    sidebarRow: {
        display: 'flex',
        padding: '4px 0px',
    },
}))

type Props = {
    session: TSession
    task: TLabelTask
    actions: BallAction[]
    playTime: number
    deleteAction: (action: BallAction) => void
    seekToAction: (action: BallAction) => void
    clickDelay: number
    setClickDelay: React.Dispatch<React.SetStateAction<number>>
}

const LabelBallSidebar = (props: Props) => {
    const classes = useStyles()

    const {
        session,
        task,
        actions,
        playTime,
        deleteAction,
        seekToAction,
        clickDelay,
        setClickDelay,
    } = props

    const fps: number =
        (session.videos &&
            session.videos.length > 0 &&
            session.videos[0].fps) ||
        25

    const foundPeriod: Period | undefined | null = findPeriodForFrames(
        session,
        task.startFrame,
        task.endFrame
    )

    const onChangeClickDelay = useCallback(
        (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const value: number = Number(event.currentTarget.value)
            value > -1 && value < 1 && setClickDelay(value)
        },
        [setClickDelay]
    )

    return (
        <React.Fragment>
            <div className={classes.sidebarRow}>
                <TextField
                    value={
                        foundPeriod ? PeriodTypeToString(foundPeriod.type) : '-'
                    }
                    label="Period"
                    disabled
                />
                <TextField value={task.id} label="Task id" disabled />
            </div>
            <div className={classes.sidebarRow}>
                <TextField
                    type="number"
                    label="Click delay"
                    value={clickDelay}
                    onChange={onChangeClickDelay}
                    inputProps={{ min: -1, max: 1, step: 0.1 }}
                />
            </div>
            <div className={classes.sidebarRow}>
                <BallActionList
                    actions={actions || []}
                    frameId={Math.round(playTime * fps)}
                    fps={fps}
                    seekToAction={seekToAction}
                    deleteAction={deleteAction}
                />
            </div>
        </React.Fragment>
    )
}

export default LabelBallSidebar
